'use client';

import { Group, Indicator, Paper, Text } from '@mantine/core';

interface ChartTooltipProps {
  label: string;
  payload: Record<string, any>[] | undefined;
}

export default function ChartTooltip({ label, payload }: ChartTooltipProps) {
  if (!payload) return null;
  // remove double entries issue for area map
  payload = payload.filter((item) => item.fill !== 'none');

  return (
    <Paper py='sm' px='lg' withBorder shadow='md' radius='md' miw={180}>
      <Group justify='space-between' align='center' mb={6}>
        <Text fw={600}>{label}</Text>
        <Text fw={600} fz='sm'>
          {payload.reduce((acc, item) => acc + item.value, 0)}
        </Text>
      </Group>
      {payload.map((item: any) => (
        <Group key={item.name} justify='space-between' align='center'>
          <Group justify='start' gap='sm'>
            <Indicator color={item.color} size={12}></Indicator>
            <Text fz='sm'>{item.name}</Text>
          </Group>
          <Text fz='sm'>{item.value}</Text>
        </Group>
      ))}
    </Paper>
  );
}
